import { USER_MENTION } from '../constants';
import type { UserMentionElement } from '../types';

/** Create a user mention element. */
export const createUserMention = (user: UserMentionElement['user']): UserMentionElement => {
    return { type: USER_MENTION, user, children: [{ text: user.fullName }] };
};
